import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Layout } from "@/components/Layout";
import Home from "@/pages/Home";
import About from "@/pages/About";
import Apps from "@/pages/Apps";
import Contact from "@/pages/Contact";
import Privacy from "@/pages/Privacy";
import Terms from "@/pages/Terms";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          {["fr", "en"].map((lang) => (
            <Route key={lang} path={lang === "en" ? "/en" : "/"} element={<Layout lang={lang} />}>
              <Route index element={<Home />} />
              <Route path="about" element={<About />} />
              <Route path="apps" element={<Apps />} />
              <Route path="contact" element={<Contact />} />
              <Route path="privacy" element={<Privacy />} />
              <Route path="terms" element={<Terms />} />
            </Route>
          ))}
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
